import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from 'src/app/core/store/store';
import { Note } from 'src/app/models/note.model';
import { CourseService } from 'src/app/shared/services/course.service';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { UtilityService } from 'src/app/shared/utils/utility.service';
import { NotesBookmarksService } from '../services/notes-bookmarks.service';

@Component({
  selector: 'app-notes-bookmark',
  templateUrl: './notes-bookmark.component.html',
  styleUrls: ['./notes-bookmark.component.scss']
})
export class NotesBookmarkComponent implements OnInit {
  notes: {
    course: string,
    courseTitle: string,
    courseLogo: string,
    modules: {
      moduleNumber: string,
      notes: Note[]
    }[

    ]
  }[

  ] = [

    ];
  books: {
    course: string,
    courseTitle: string,
    courseLogo: string,
    modules: {
      moduleNumber: string,
      notes: Note[]
    }[

    ]
  }[

  ] = [

    ];

  isLoader;
  user: any;
  activation: any;

  constructor(private nBService: NotesBookmarksService,
     private route: ActivatedRoute, private router: Router,
     private dashboardService:DashboardService, private utilityService: UtilityService, private store: Store, private eventsService: EventsService,
     private courseService: CourseService) { }
  programactivationId: string = ""
  type: any;
  storeData: any;
  filterNotes: any = [];
  bookmarks: any[] = [];
  filterBookmarks: any = [];
  bookmarksData: any;
  // expandedIndex

  ngOnInit(): void {
    // this.expandedIndex = 1

    // this.route.params.subscribe(params => {
    //   this.programactivationId = params['programactivationId']
    //   this.type = params['type']
    // });
    this.getProgramActivation();

    this.store.select('user').subscribe((user: any) => {
      this.user = user;
    });
    this.store.select('activation').subscribe((activation: any) => {
      if(activation && activation[0]) {
        this.activation = activation[0];
      }
    });

  }

  getProgramActivation() {
    this.isLoader = true;
    this.programactivationId = JSON.parse(localStorage.getItem('activationInfo')).programActivationId
    // this.dashboardService.getProgramActivation().subscribe(
    //   (res: any) => {
    //     if(res && res['data'] && res['data'].length) { 
          // this.programactivationId = res.data[0].programActivationId;
          this.getNotesInformation(this.programactivationId);
          this.getBookmarksInformation(this.programactivationId);
          this.isLoader = false;
    //       this.activation = res.data[0];
    //     }
    //   }, (error) => {
    //     this.isLoader = false;
    //     console.log(error);
    //   }
    // );
  }

  getNotesInformation(programactivationId) {
    this.nBService.getNotesData(programactivationId,"NOTES").subscribe((notes) => {
      this.storeData = notes
      if (notes) {
        this.notes = [];
        let groupedByCourse = [];
        for (let note of this.storeData.data) {
          let course = groupedByCourse.find(n => n.course == note.course) as any;
          if (course) course.modules.push(note);
          if (course) course.notes.push(note);

          else groupedByCourse.push({
            course: note.course, courseLogo: note.courseLogo,
            courseTitle: note.courseTitle, modules: [note],
            notes: [note]
          });
        }
        let groupbyModules = []
        for (let course of groupedByCourse) {
          for (let note of course.modules) {
            let module = groupbyModules.find(m => m.moduleNumber == note.moduleNumber);
            if (module) {
              module.notes.push(note)
            }
            else {
              groupbyModules.push({ moduleNumber: note.moduleNumber, moduleName: note.moduleName, notes: [note] })
            }
          }
          this.notes.push({ ...course, modules: groupbyModules })
          groupbyModules = [];
        }
        this.filterNotes = JSON.parse(JSON.stringify(this.notes));
        this.filterNotes.map((v, i) => (i == 0) ?  v.collapse = true : v.collapse = false);
      }
    console.log(notes);

    }, error => {
      console.log(error);
    })
  }

  getBookmarksInformation(programactivationId) {
    this.nBService.getNotesData(programactivationId, "BOOKMARKS").subscribe((result) => {
      this.bookmarksData = result
      if (result) {
        this.notes = [];
        let groupedByCourse = [];
        for (let note of this.bookmarksData.data) {
          let books = groupedByCourse.find(n => n.course == note.course) as any;
          if (books) books.modules.push(note);
          if (books) books.notes.push(note);

          else groupedByCourse.push({
            course: note.course, courseLogo: note.courseLogo,
            courseTitle: note.courseTitle, modules: [note],
            notes: [note]
          });
        }
        let groupbyModules = []
        for (let course of groupedByCourse) {
          for (let note of course.modules) {
            let module = groupbyModules.find(m => m.moduleNumber == note.moduleNumber);
            if (module) {
              module.notes.push(note)

            }
            else {
              groupbyModules.push({
                moduleNumber: note.moduleNumber,
                moduleName: note.moduleName, notes: [note]
              })
            }
          }
          this.books.push({ ...course, modules: groupbyModules })
          groupbyModules = [];
        }

        this.filterBookmarks = JSON.parse(JSON.stringify(this.books));
        this.filterBookmarks.map((v, i) => (i == 0) ?  v.collapse = true : v.collapse = false);

      }
    }, error => {
      console.log(error);
    })
  }


  transform(value: number, type: string): any {
    if (type == "absoluteHours") {
      value = value / 3600;
      let res = Math.round(value * 10) / 10
      return res;
    }
    else if (type == "absoluteMinutes") {
      return Math.round(value / 60) == 1 ? `${Math.round(value / 60)} Minute` : `${Math.round(value / 60)} Minutes`;
    }
    if (isNaN(value)) value = 0;
    let hours = Math.floor(value / 3600);
    let minutes = Math.floor((value - hours * 3600) / 60);
    let seconds = Math.floor(value - hours * 3600 - minutes * 60);
    if (type == 'printUnits')
      return hours ? `${(hours + "").padStart(2, '0')}h ${(minutes + "").padStart(2, '0')}m ${(seconds + "").padStart(2, '0')}s` : `${(minutes + "").padStart(2, '0')}m ${(seconds + "").padStart(2, '0')}s`;
    if (type == 'printShortUnits')
      return hours ? `${(hours + "")}h ${(minutes + "")}m` : `${(minutes + "")}m`;
    else return hours ? `${(hours + "").padStart(2, '0')}:${(minutes + "").padStart(2, '0')}:${(seconds + "").padStart(2, '0')}` : `${(minutes + "").padStart(2, '0')}:${(seconds + "").padStart(2, '0')}`;
  }

  // Collaps(index: number) {
  //   console.log(index,"Index");
  //   this.expandedIndex = index === this.expandedIndex ? -1 : index;
  //   console.log(this.expandedIndex,"Expanded");
  //   }

  openTab(evt, tabName) {
    // Declare all variables
    var i, tabcontent, tablinks;
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("notes__bookmarks--tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
    // event capture
    if(tabName=='tabNotes'){
      this.notesBookmarksEventFunction("Notes tab");
    }
    else if(tabName=='tabBookmarks'){
      this.notesBookmarksEventFunction("Bookmarks tab");
    }
  }


  navigateToPlayerBookmarks(type, contentId, courseId) {
    // capture event
    try {   
      if(this.user && this.activation && this.bookmarksData && this.bookmarksData.data && this.bookmarksData.data.length){
        let eventData = { user: this.user, activationData: this.activation, bookmarkData: this.bookmarksData}
        this.eventsService.viewBookmarksEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
    !this.utilityService.isNavigateToContentExists() && this.utilityService.setModuleNavigationData(type, contentId);
    window.open(`/player/${courseId}`, '_blank');
  }

  notesBookmarksEventFunction(eventName){
    try {   
      if(this.user && eventName && this.activation){
        let eventData = { user: this.user, eventName: eventName, activationData: this.activation}
        this.eventsService.notesBookmarksTabEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }

  deleteNote(note) {
    this.courseService.deleteNote(note._id).subscribe(() => {
      this.getNotesInformation(this.programactivationId);
    })
  }
  
  navigateToPlayer(note) {
    !this.utilityService.isNavigateToContentExists() && this.utilityService.setNotesNavigationData(note.content, note.recordedTime, note._id);
    window.open(`/player/${note.course}`, '_blank');
  }

}
